// extracted by mini-css-extract-plugin
export default {"description":"LogoutConfirmModal-module__description--l_3d0","actions":"LogoutConfirmModal-module__actions--GGqu5"};